// import Image from "next/image"
// import { createRoot } from 'react-dom/client';
// import ReactModal from "react-modal"
// import { RxCross2 } from "react-icons/rx";
// import freeLogo from '../../assets/Images/free_tag.png'
// import app_download_qr from '../../assets/Images/app_download_qr.webp';
// import { BsApple, BsTelephone } from "react-icons/bs";
// import { BlackButton } from "../Button/Button";
// import { isMobile } from 'react-device-detect';
// import Link from "next/link";
// import axios from "axios";
// import { useState, useEffect, Suspense, useContext } from "react";
// import { AiFillInfoCircle } from "react-icons/ai";
// import { toast } from "../Toast/Toast";
// import LogInBf from "../LogIn/LogInBf";
// import ActivePlanSection from '@/components/ProPage2/ActivePlanSection';
// import axiosInterceptorInstance from '../axiosInterceptorInstance';
// import { Mixpanel } from "../Mixpanel";

// const customStyles = {
//     content: {
//         top: 'auto',
//         left: isMobile ? '0' : '50%',
//         right: isMobile ? '0' : 'auto',
//         bottom: isMobile ? '0' : '50%',
//         transform: !isMobile && 'translate(-50%, 50%)',
//         width: isMobile ? '100%' : '780px',
//         height: isMobile ? '60%' : '404px',
//         backgroundColor: 'transparent',
//         borderColor: 'transparent',
//     },
//     overlay: {
//         backdropFilter: "blur(2px)",
//         backgroundColor: '#20202099',
//         zIndex: 20
//     }
// }

// const PopUp = ({ isProPage, userDetail }) => {
//     const [number, setNumber] = useState('')
//     const [userData, setUserData] = useState(userDetail?.userData)
//     const [error, setError] = useState(null)
//     const [step, setStep] = useState(1);

//     const sendOtp = () => {
//         var IndNum = /^[0]?[6789]\d{9}$/;
//         if (number.length === 10 && IndNum.test(number)) {
//             axiosInterceptorInstance.get(`api/auth/send-otp?type=web4&countryCode=91&contactNumber=${number}`)
//             setStep(2)
//             Mixpanel.track('cta_clicked', {
//                 'cta_text': userDetail?.btn?.beforeLogin,
//                 'page': userDetail?.btn?.isProPage ? 'web_pro_page' : 'web_elite_page',
//                 'phone_filled': true,
//                 'widget': 'bottom_sticky'
//             })
//             Mixpanel.pageView({
//                 'page': 'web_otp_page'
//             })
//         } else if (number.length === 0) {
//             userDetail?.inputRef.current?.focus()
//             Mixpanel.track('cta_clicked', {
//                 'page': userDetail?.btn?.isProPage ? 'web_pro_page' : 'web_elite_page',
//                 'phone_filled': false,
//                 'widget': 'bottom_sticky'
//             })
//             setError('Mobile number is required')
//         } else {
//             userDetail?.inputRef.current?.focus()
//             setError('Please enter a valid mobile number')
//         }
//     }
//     return (
//         <ReactModal
//             isOpen={true}
//             ariaHideApp={false}
//             shouldFocusAfterRender={false}
//             onRequestClose={popUp.close}
//             style={customStyles}
//         >
//             {(step == 1) && !userDetail?.userData?.authToken ? < div className='select-none font-Inter flex flex-col md:flex-row justify-between relative h-full py-12 px-8 bg-white rounded-2xl'>
//                 <button onClick={popUp.close} className='absolute right-8 -top-5 bg-white p-2 rounded-full z-50'>
//                     <RxCross2 size={28} />
//                 </button>
//                 <div className="flex flex-col justify-between ">
//                     <div className="flex flex-col items-start gap-2 self-stretch">
//                         <div className=" max-w-fit flex justify-center items-start gap-[10.673px] [background:#1F1D1F] py-3 px-6 rounded-[259.556px] border-[1.28px] border-solid border-white">
//                             <Image className="w-[75.649px]" src={freeLogo} alt="demo" />
//                             <p className="text-white text-[21.333px] font-extrabold leading-[35.556px]">7 DAYS TRIAL</p>
//                         </div>
//                         <p className="text-[color:var(--Neutral-600,#747474)] text-sm font-medium leading-6">Unlock free trade ideas from SEBI experts by downloading the <br /> Univest App app now!</p>
//                     </div>
//                     <div className="flex flex-col items-start gap-2">
//                         <p className="text-[color:var(--Neutral-900,#202020)] text-2xl font-extrabold leading-10">Get OTP</p>
//                         <div className='w-full sm:w-[480px] h-10 md:h-14 flex items-center bg-[#FFF] rounded-full border border-[#606060] text-xs md:text-base font-medium'>
//                             <BsTelephone className='h-4 md:h-14 ml-4 md:ml-6' color="#747474" size={24} />
//                             <input className='w-[calc(100%-120px)] caret-primary ml-2.5 md:ml-4 text-[#747474]' type='text' placeholder='Enter your mobile number'
//                                 value={number} pattern="[0-9]*" inputMode="numeric" onChange={(e) => {
//                                     var numbers = /^[0-9]+$/;
//                                     if (e.target.value.match(numbers) || e.target.value === '') {
//                                         setError(null)
//                                     } else {
//                                         setError('Please enter a valid number')
//                                     }
//                                     setNumber(e.target.value)
//                                 }} />
//                             <BlackButton className='whitespace-nowrap px-3 md:px-6 h-full ml-auto' text='Get free advice' icon={true} onClick={sendOtp} />
//                         </div>
//                     </div>
//                     {error &&
//                         <div className='flex items-center ml-2 mt-1 '>
//                             <AiFillInfoCircle color='#EB4E2C' className='text-[12px] mr-1' />
//                             <div className={`text-[10px] ${error ? 'text-[#EB4E2C]' : 'text-[#747474]'}`}>
//                                 {error}
//                             </div>
//                         </div>}
//                 </div>
//                 <div className='flex flex-col justify-between '>
//                     <div className="p-2 border border-black rounded">
//                         <Image src={app_download_qr} className='w-28' alt="download now qr" />
//                     </div>
//                     <p className='text-sm text-black mb-3 text-center'>
//                         Scan to Download
//                     </p>
//                     <Link href="https://play.google.com/store/apps/details?id=com.univest.capp" className="bg-black flex items-center border rounded-lg px-2 py-1 w-32 transition hover:opacity-75">
//                         <Image src="https://cdn-icons-png.flaticon.com/512/888/888857.png" width={20} height={20} className="w-6" alt='Google Play' />
//                         <div className="text-left ml-2">
//                             <p className='text-[8px] text-white'>Download on </p>
//                             <p className="text-xs font-bold text-white">Google Play</p>
//                         </div>
//                     </Link>
//                     <Link href="https://apps.apple.com/us/app/univest-empowering-wealth/id6443753518" className="bg-black flex items-center border rounded-lg px-2 py-1.5 w-32 transition hover:opacity-75">
//                         <BsApple color='#FFFFFF' size={24} />
//                         <div className="text-left ml-2">
//                             <p className='text-[8px] text-white'>Download on </p>
//                             <p className="text-xs font-bold text-white">Apple Store</p>
//                         </div>
//                     </Link>
//                 </div>
//             </div>
//                 : <div className="select-none font-Inter relative py-8 px-8 bg-white rounded-2xl">
//                     <button onClick={popUp.close} className='absolute right-8 -top-5 bg-white p-2 rounded-full z-50'>
//                         <RxCross2 size={28} />
//                     </button>
//                     {(userData?.authToken ?
//                         <ActivePlanSection userData={userData} />
//                         : <LogInBf isProPage={userDetail?.btn?.isProPage} userData={userData} setUserData={(e) => { userDetail?.setUserData(e); setUserData(e) }} setModal={userDetail?.setModal} number={number} inputRef={userDetail?.inputRef} sendOtp={sendOtp} />)}
//                 </div>}
//         </ReactModal>
//     )
// }
// var root = null;
// export const popUp = {
//     currentPopup: false,
//     close: () => {
//         root?.unmount()
//         popUp.currentPopup = false
//     },
//     open: (userDetail) => {
//         root = createRoot(document.getElementById('pop-up-container'))
//         if (isMobile) {
//             window.open('https://univest.onelink.me/VC6b/investwithunivest', '_blank');
//         } else {
//             if (popUp.currentPopup) {
//                 popUp.close()
//             }
//             root?.render(<PopUp userDetail={userDetail} />);
//             popUp.currentPopup = true
//         }
//     }
// }

export const popUp = {
    open: () => {
        window.location.href = `${window.location.origin}/user/log-in`;
    }
};
